import 'moment/locale/pt-br'
import moment from 'moment'
moment.locale('pt-br') /* outside function to set configuration to global moment instance */

export default {
  install(VueInstance, options) {
    VueInstance.prototype.$moment = moment
  },
}
